import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useState } from "react"

/**
 * useUnextractedEarnings - 获取未提取收益 Hook（查询类）
 * 
 * 用于调用 FlowDeposit 合约的 pending 方法获取指定质押记录的待提取收益。
 * 需要传入质押记录 ID 才能查询，因此不支持自动执行。
 * 
 * @returns {Object} 返回未提取收益、加载状态和获取方法
 *   - unextractedEarnings: 未提取收益金额
 *   - unextractedEarningsBalanceLod: 加载状态
 *   - getUnextractedEarnings: 获取未提取收益的函数
 */
const useUnextractedEarnings = () => {
    // 未提取收益状态
    const [unextractedEarnings, setUnextractedEarningsBalance] = useState<bigint>(BigInt(0))
    // 加载状态
    const [unextractedEarningsBalanceLod, setLoading] = useState(false)
    // 从 useConnectWallet 获取 FlexibleStaking 合约实例和用户地址
    const { contractEvm: { FlexibleStaking }, address } = useConnectWallet()

    /**
     * 获取未提取收益函数
     * @param id - 质押记录的 ID
     */
    const getUnextractedEarnings = useCallback(async (id: bigint) => {
        if (FlexibleStaking) {
            setLoading(true)
            try {
                // 调用合约的 pending 方法获取待提取收益
                const res = await FlexibleStaking?.pending(address, id)
                setUnextractedEarningsBalance(res)
            } catch (e) {
                console.log('useUnextractedEarnings', e);
                setUnextractedEarningsBalance(BigInt(0))
            }
            setLoading(false)
        }
    }, [FlexibleStaking, address])

    return { unextractedEarnings, unextractedEarningsBalanceLod, getUnextractedEarnings }
}

export default useUnextractedEarnings